"use strict";

var LoggerInstance = require("js-logger").get("GivingStatementHelper");

var AccountStore = require("./AccountStore");

var ActionsHelper = require("../actions/ActionsHelper");

var WizardConstants = require("../constants/WizardConstants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var GivingStatementRequestFormSelector = "[data-component='givingStatementRequestForm']";
var PrintGivingStatementButtonSelector = "[data-component='printGivingStatementButton']";
var StartDateSelector = "[data-component='givingStatementRequestForm.startDate']";
var EndDateSelector = "[data-component='givingStatementRequestForm.endDate']";

var GivingStatementHelper = {
	formatDate(dateObj) {
		return dateObj.format("YYYY-MM-DD");
	},

	getDateFromString: function (dateString) {
		var date = moment(dateString);

		//Moment essentially converts something like "010121" in "01/01/10121" so making sure the year range is valid for dates
		if (!date.isValid() || date.year() < 1753 || date.year() > 9999) {
			return null;
		}

		return date;
	},

	initializeGivingStatementRequestForm: function (event) {
		var $form = $(GivingStatementRequestFormSelector);

		if (!$form.length) {
			return;
		}

		$form.off("submit.givingStatementRequestForm");
		$form.on("submit.givingStatementRequestForm", this.submitRequest.bind(this));
	},

	initializePrintButtons: function (event) {
		$(PrintGivingStatementButtonSelector).each((index, button) => {
			var $button = $(button);

			$button.off("click.printGivingStatementButton");
			$button.on("click.printGivingStatementButton", this.printGivingStatement.bind(this));
		});
	},

	printGivingStatement: function (event) {
		event = this._getEventOrReturn(event, "Print giving statement request called successfully.");
		if (!event) {
			return;
		}

		window.print();
	},

	submitRequest: function (event) {
		event = this._getEventOrReturn(event, "Giving statement request called successfully.");
		if (!event) {
			return;
		}

		// we need to parse out start and end date,
		// and then redirect to the statement page with dates in url parameters.
		var $form = $(event.target);

		var startMoment = this.getDateFromString($form.find(StartDateSelector).val());
		var endMoment = this.getDateFromString($form.find(EndDateSelector).val());

		if (startMoment === null || endMoment === null) {
			BootstrapPrompt.alert(
				AccountStore.getWizardValue(
					WizardConstants.WIZARDS.YEAR_END_GIVING_STATEMENT_DISPLAY_MESSAGES,
					WizardConstants.YEAR_END_GIVING_STATEMENT_MESSAGE_FIELDS.INVALID_DATE
				));
			return;
		}

		if (startMoment.isSameOrAfter(endMoment)) {
			BootstrapPrompt.alert(
				AccountStore.getWizardValue(
					WizardConstants.WIZARDS.YEAR_END_GIVING_STATEMENT_DISPLAY_MESSAGES,
					WizardConstants.YEAR_END_GIVING_STATEMENT_MESSAGE_FIELDS.INVALID_DATE_RANGE
				));
			return;
		}

		var urlString = `/yearendgivingstatement?startDate=${this.formatDate(startMoment)}&endDate=${this.formatDate(endMoment)}`;

		window.location.href = urlString;

		return false;
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, AccountStore.get("isDesignMode"), isDesignModeMessage);
	}
};

module.exports = GivingStatementHelper;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/GivingStatementHelper.jsx